import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useState } from 'react';
import { TranslationsKeys } from '../orgs-interface';
import styles from './delete-confirmation-modal.module.scss';
export const DeleteConfirmationModal = ({ title, onDeleteConfirm, onDeleteModalClose, name, showLoader = false, canDeleteOrg = false, }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [confirmText, setConfirmText] = useState('');
    const onDismissModal = () => {
        setIsModalOpen(false);
        onDeleteModalClose();
    };
    const canNotDeleteOrgConfig = {
        isOpen: isModalOpen,
        title: t(TranslationsKeys.ORG_CAN_NOT_DELETE_TITLE),
        description: t(TranslationsKeys.CAN_NOT_DELETE_ORG_DESC),
        primaryButton: {
            text: t(TranslationsKeys.MODAL_OK),
            onConfirm: onDismissModal,
        },
        secondaryButton: {
            text: t(TranslationsKeys.CANCEL),
            onClick: onDismissModal,
        },
    };
    const CONFIRM = t(TranslationsKeys.CONFIRM);
    return !canDeleteOrg ? (React.createElement(Alert.Dialogue, { ...canNotDeleteOrgConfig })) : (React.createElement(Modal, { size: ModalSize.SMALL, title: title, isOpen: isModalOpen, confirmButton: {
            text: t(TranslationsKeys.DELETE),
            onConfirm: () => {
                if (CONFIRM === confirmText) {
                    setIsModalOpen(false);
                    onDeleteConfirm();
                }
            },
            isLoading: showLoader,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onDismissModal },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement(Alert.Banner, { message: t(TranslationsKeys.DELETE_ORG_MODAL_BODY, {
                    itemName: name,
                }), isVisible: true, showCloseButton: false, type: BannerAlertType.WARNING, className: styles.alertWarnBanner }),
            React.createElement("div", { "data-testid": "delete-confirmation-body" },
                React.createElement(Typography, { variant: "content-label-subhead", color: CONFIRM !== confirmText
                        ? Colors.failure
                        : Colors.base, noMargin: true }, t(TranslationsKeys.DELETE_ORG_CONFIRM_LABEL)),
                React.createElement(Input.Text, { ariaLabel: t(TranslationsKeys.DELETE_ORG_CONFIRM_LABEL), value: confirmText, hasError: CONFIRM !== confirmText, "data-testid": "confirmInput", onChange: (event) => {
                        const { value } = event.target;
                        setConfirmText(value.toUpperCase());
                    } })))));
};
//# sourceMappingURL=delete-confirmation-modal.js.map